module.exports = __webpack_public_path__ + "media/income_verifications/income-verifications-background-f26b42b9.jpg";